import { AnalyticsEvent } from '../models';

export class ProductViewEvent implements AnalyticsEvent {
  name = 'ProductViewEvent';
  constructor(public readonly productName: string, public readonly isEditMode: boolean, public readonly mealType: string, public readonly isMealBuilderMobileCustomizationsExperienceSubscribed: boolean, public readonly isWebMobile: boolean) {}
}
